import es_ES from './es-ES'

export default {
  'es-ES': es_ES
}
